import * as types from './constants';

export default {

	[types.SET_QUESTIONS](state, value) {
		state.questions = value;
	},

	[types.SET_QUESTION](state, value) {
		state.question = value
	},

	[types.SET_QUESTION_GROUP](state, data) {
		state.question_group = data;
	},

	[types.VALIDATE_QUESTION](state, value) {
		state.validate_question = value;
	},

	[types.SET_CORRECT_GROUP_VALUE](state, value) {
		state.correctChoosed = value;
	},

	[types.SET_VITURAL_KEYBOARD_VALUE](state, value) {
		state.valVituralKeyboard = value;
	},

	[types.SET_QUESTION_DATA_4_CHECK_ANSWER](state, value) {
		state.questionDataCheckAnswer = value;
	},

	[types.SET_QUESTION_LIST_4_CHECK_ANSWER](state, value) {
		state.questionList4CheckAnswer = value;
	},

  [types.SET_TXT_SELECTED_INPUT](state, value) {
    state.textSelectedData = value;
  },
};